import React from 'react'
import './copy.css'
function Copyright() {
  return (
    <div style={{backgroundColor:"#cadfff",display:"flex",justifyContent:"center",padding:"10px"}}>
            <div className='copyright_css' style={{textAlign:"center"}}>Copyright © {new Date().getFullYear()} SharpITS. All rights reserved</div>

    </div>
  )
}

export default Copyright